"use strict";

/**
	@typedef InnerCollectionDescriptor
	@property {String[]} [keyNames=[]] The keynames of inner collection
*/

/**
	@param {String[]} [keyNames=[]]
	@param {InnerCollectionDescriptor} [multi]
	@param {Object} [key] Egy-egy belső collection számára fenntartott paraméter (példányonként).
	
	Ha nem nevezünk meg kulcsokat,
	akkor feltételezzük, hogy
	az elemek maguk a kulcsok,
	azaz: primitívek .
*/

import {EventEmitter} from "events";

export default class Collection extends EventEmitter {
	
	constructor( options = {} ) {
		
		super();
		
		this.setMaxListeners(Infinity);
		
		this.keyNames = options.keyNames || [];
		
		if (options.key)
			this.key = options.key;
		
		if (options.multi)
			this.setMultiDimensional(options.multi);
		
		this.items = null;
		this.map = {};
	}
	
	// PUBLIC METHODS
	
	get(key) {
		const index = this.resolveKey(key);
		if (index === null) {
			if (this.multi) {
				return this.createInnerCollection(key);
			} else {
				return null;
			}
		}
		return this.items[index];
	}
	
	getAll() {
		return this.items;
	}
	
	// PRIVATE METHODS
	
	setMultiDimensional(innerCollectionDescriptor) {
		this.multi = true;
		this.innerCollectionDescriptor = innerCollectionDescriptor;
	}
	
	createInnerCollection(key) {
		const innerCollection = new Collection({
			keyNames:	this.innerCollectionDescriptor.keyNames || [],
			key:		key
		});
		// nem emittálunk ilyenkor
		this.items = this.items || [];
		this.items.push(innerCollection);
		this.createMap();
		
		return innerCollection;
	}
	
	// Több dimmenziós collection-ök esetében
	// a belső collection-ök kulccsal rendelkeznek.
	// Ezek elérésére van a getKey függvény.
	getKey() {
		return this.key || null;
	}
	
	createMap() {
		
		this.map = {};
		
		if (!this.items)
			return;
		
		this.items.forEach( (item, index) => {
			if (this.multi)
				this.map[item.getKey()] = index;
			else if (this.keyNames.length)
				this.keyNames.forEach((keyName, keyNameIndex) => this.map[item[keyName]] = index);
			else
				this.map[item] = index;
		});
	}
	
	resolveKey(key) {
		
		if (!key)
			throw new Error("Missing key");
		
		const index = this.map[key];
		
		if (index === undefined)
			return null;
		
		return index;
	}
	
	getDefaultKey() {
		if (this.keyNames && this.keyNames.length)
			return this.keyNames[0];
		else return null;
	}
	
	contains(item) {
		const defaultKey = this.getDefaultKey();
		if (!defaultKey) {
			return this.get(item) ? true : false;
		} else {
			return this.get(item[defaultKey]) ? true : false;
		}
	}
	
	set(items) {
		this.items = items;
		this.createMap();
		this.emit('change', this.items);
		this.emit('set', items);
	}
		
	insert(items) {
		this.items = this.items || [];
		
		items.forEach(item => {
			if (this.contains(item))
				return;
			this.items.push(item);
		});
		
		this.createMap();
		this.emit('change', this.items);
		this.emit('insert', items);
	}
	
	update(key, item) {
		const index = this.resolveKey(key);
		if (index === null)
			return;
		
		this.items[index] = item;
		this.createMap();
		this.emit('change', this.items);
		this.emit('update', item);
	}
		
	remove(keys) {
		if (!keys)
			return;
		
		if (!this.items || this.items.length == 0)
			return;
		
		const items = [];
		
		keys.forEach(key => {
			const index = this.resolveKey(key);
			if (index === null)
				return;
			
			items.push(this.items.splice(index, 1)[0]);
			this.createMap();
		});
		
		this.emit('change', this.items);
		this.emit('remove', items);
	}
}


// WEBPACK FOOTER //
// ./~/vwa/flux/Collection.js